import { render } from "./commentsEditor.vue?vue&type=template&id=4dd3a3f5&scoped=true"
import script from "./commentsEditor.vue?vue&type=script&lang=js"
export * from "./commentsEditor.vue?vue&type=script&lang=js"

import "./commentsEditor.vue?vue&type=style&index=0&id=4dd3a3f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd3a3f5"]])

export default __exports__